import { DataTable } from "@/components/data-table";
import { ListPage } from "@/components/list-page";

export default function CajaUnassigned() {
    return <ListPage>
        <ListPage.Header>
            <ListPage.Header.Actions title="Caja Actual" />
        </ListPage.Header>
        <DataTable flex={1}>
            <DataTable.Content
                fit="flex"
                emptyText="No hay ninguna caja asignada a este dispositivo."
            />
        </DataTable>
    </ListPage>
}